import React from 'react';
import './publicInvite.scss';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useLocation } from 'react-router-dom';
import { Button } from 'devextreme-react';
import { loginRequest } from '../../authConfig';
import { SingleCard } from '../../layouts';
import InvitoShowToken from '../../components/InvitoShowToken/InvitoShowToken';
import { jwtDecode, JwtPayload } from 'jwt-decode';

export default function PublicInvite() {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e: Error) => {
      console.log(e.message);
    });
  };

  try {
    const decoded: any = jwtDecode<JwtPayload>(String(token));

    return (
      <SingleCard title="Invito a partecipare a Hyper-GES" >
        <div className='invite-form'>
          <PresentationRender />
          <InvitoShowToken jwtPayload={decoded} />

          <div className='center-button'>
            <Button
              text="Accedi o registrati"
              type='default'
              onClick={handleLogin}
              height={50} />
          </div>
        </div>
      </SingleCard>
    );
  }
  catch {
    return (
      <React.Fragment>
        Link di invito non valido.
      </React.Fragment>
    )
  }
}

function PresentationRender() {
  return (
    <section>
      <h4>Cos'è Hyper-GES?</h4>
      <p>
        Una piattaforma digitale in cloud per la <strong>Gestione delle Esigenze Sociali</strong>, integrata nel <strong>Piano di Emergenza Comunale (PEC)</strong>.
      </p>

      <h4>A cosa serve?</h4>
      <p>
        Permette al Comune di <strong>mappare, aggiornare e condividere in sicurezza</strong> le informazioni sui soggetti socialmente deboli (anziani, disabili, malati), per garantire un intervento tempestivo in caso di emergenza.
      </p>
    </section>
  );
}

